import { callApi } from './api';

import { ApiResult } from '@/types/api';
import { SupportPlanDraft } from '@/types/supportPlan';

export const getSupportPlanDraft = async (id: number): Promise<ApiResult<SupportPlanDraft>> => {
  const { status, result } = await callApi<SupportPlanDraft>(
    `support-plan-drafts/${id}`,
    'GET',
    undefined,
    undefined,
    undefined,
    undefined,
    true
  );
  return { status, result };
};
